export default {
      id: "export-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#export",
      toString: function () {
        return this.url;
      }
    }